import React from "react";
import DesktopGame from "./DesktopGame";
import GameScreenshots from "./GameScreenshots";

export default function DesktopContent({ gameData, isArcademics, canPlayGame, publicModalToggle }) {
  if (canPlayGame) {
    return <DesktopGame gameData={gameData} isArcademics={isArcademics} />;
  }
  return <GameScreenshots game={gameData} clickHandler={publicModalToggle} />;
}
